import { FREE_RENT } from "../../../../../core/service/BusinessLogicService"
import { string } from "prop-types"
import React from "react"
import { Col, Row } from "react-bootstrap"

export default function ActivePromoTypePills({ promoType, promoCode, promoDescription }) {
  return (
    <li>
      <Row>
        {promoType === FREE_RENT && (
          <>
            <Col>
              <p>
                <small>{promoCode || ""}</small>
              </p>
            </Col>

            <Col>
              <p className="text-right">
                <small>
                  <span className="badge badge-pill badge-primary">{promoDescription || ""}</span>
                </small>
              </p>
            </Col>
          </>
        )}
      </Row>
    </li>
  )
}

ActivePromoTypePills.propTypes = {
  promoType: string,
  promoCode: string,
  promoDescription: string
}
